import defaultState from "./state";

const eliminarPrestacionFormReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CONFIRMACION_GUARDADO_ELIMINACION": {
      return Object.assign({}, state, {
        aceptaGuardadoModal: action.aceptaGuardadoModal,
      });
    }

    case "CARGAR_DETALLE_PRESTACION_ELIMINACION": {
      if (action.detallePrestacion && action.detallePrestacion.length > 0) {
        const detallePrestacion = Object.assign({}, state.detallePrestacion, {
          codigoPrestacionPrestador: action.detallePrestacion[0].ARPR_PRES_CCOD_PRESTADOR,
          pabellonPrestacion: action.detallePrestacion[0].GUARISMO,
          glosaPrestacionPrestador: action.detallePrestacion[0].ARPR_PRES_TDESC_PRESTAD,
          codigoFonasa: action.detallePrestacion[0].COD_FONASA,
          grupoPrestacionIsapre: action.detallePrestacion[0].GRBA_CCOD,
          codigoPrestacionIsapre: action.detallePrestacion[0].COD_ISAPRE,
          glosaPrestacionIsapre: action.detallePrestacion[0].PRES_TDESC,
          codigoProfesional: action.detallePrestacion[0].PROF_CCOD,
          montoArancelPrestacion: action.detallePrestacion[0].ARPR_MARANCEL,
          unidadArancelPrestacion: action.detallePrestacion[0].UNID_CCOD,
          inicioVigenciaArancelPrev: action.detallePrestacion[0].ARPR_FINICIAL,
          tipoAtencion: action.detallePrestacion[0].TIPO_ATENCION,
          grupoPrestacionPrestador: action.detallePrestacion[0].GRBA_CCOD,
          itemImed: action.detallePrestacion[0].ITEM_IMED,
          glosagGupoPrestacionIsapre: action.detallePrestacion[0].GRBO_DESCRIPCION,
          IdPrestacion: action.detallePrestacion[0].ID_PRESTACION,
        });
        return Object.assign({}, state, {
          detallePrestacion,
        });
      }
      return state;
    }

    case "CAMBIAR_VIGENCIA_PRESTACION_ELIMINACION": {
      return Object.assign({}, state, {
        vigenciaPrestacionEliminacion: action.vigenciaPrestacionEliminacion,
        vigenciaPrestacionEliminacionError: action.error,
      });
    }

    case "OPEN_CARGAR_BORRADOR_ELIMINAR_PRESTACION": {
      return Object.assign({}, state, {
        loading: false,
        aceptaGuardadoModalEliminacion: action.aceptaGuardadoModalEliminacion,
      });
    }

    case "CARGAR_CENTROS_PRESTACION_ELI": {
      const centrosAtencionPrestacionAux = [];
      action.detalleCentros.forEach((arancel) => {
        centrosAtencionPrestacionAux.push({
          Rut: arancel.RutArancel,
          DescripcionArancel: arancel.DescripcionArancel,
          Secuencia: arancel.Secuencia,
          Descripcion: arancel.Descripcion,
          Valor: arancel.MontoPrestacion,
          Unidad: arancel.Unidad,
          DescPrestacion: arancel.DescripcionPrestacion,
          FechaInicio: arancel.FechaInicio,
          FechaTermino: arancel.FechaTermino,
          IdPrestacion: arancel.IdPrestacion,
          tipoAtencion: arancel.tipoAtencion,
          checked: false,
        });
      });
      return Object.assign({}, state, {
        centrosAtencionPrestacion: centrosAtencionPrestacionAux,
      });
    }

    case "CHECK_PRESTACIONES_ELI": {
      return Object.assign({}, state, {
        centrosAtencionPrestacion: state.centrosAtencionPrestacion
          .map((p) => Object.assign({}, p, {
            checked: action.IdPrestacion === p.IdPrestacion ?
              action.checked : p.checked,
          })),
      });
    }

    case "EDIT_ELI_PREST/LOADING_ARBOL_DETALLE": {
      return Object.assign({}, state, {
        loadingArbolDetalle: action.load,
      });
    }

    case "DEL_PREST/SHOW_DUPS_MSG": {
      return Object.assign({}, state, {
        dupsMsg: action.dupsMsg
      })
    }

    default:
      return state;
  }
};

export default eliminarPrestacionFormReducer;
